import mixinActions from '../core/actions';
import feedActions from '../core/actions/feed';
import mixinGetters from '../core/getters/index';
import mixinMutations from '../core/mutations/index';
import Vue from 'vue';
import constants from 'Helpers/constants';
import store from '~/store';
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        extraFeeds: [],
        filters: {
            line: constants.LINE_MAIN,
            customLeagueIds: null,
            leagueGroupId: [],
            periodTypeId: constants.GAME_PERIOD_FT,
            marketId: null,
            customEventId: null,
            search: null,
            betCustomEventIds: [], //Open BetDialogs
            favoriteCustomEventIds: [],
            customColumns: [],
            isFantasyExclude: true,
            isPositionOnly: false,
        },
        isShowExtraFilters: false,
        betFeedData: {},
    },

    mutations: {
        ...mixinMutations(),
        setBetFeedData(state, data) {
            if (data.betFeedData === null) {
                Vue.delete(state.betFeedData, data.idx);
            } else {
                Vue.set(state.betFeedData, data.idx, data.betFeedData);
            }
        },
    },

    getters: {
        ...mixinGetters(),
        getList(state) {
            let live = store.getters['FeedLiveModule/getList'];
            let dball = store.getters['FeedDballModule/getTodayList'];
            let early = store.getters['FeedDballModule/getEarlyList'];

            return [...live, ...dball, ...early];
        },
        getBetFeedData(state) {
            return state.betFeedData;
        },
        getMarketName(state) {
            return state.marketName;
        },
        getFeedLeague(state) {
            let live = store.getters['FeedLiveModule/getFeedLeague'];
            let today = store.getters['FeedDballModule/getTodayFeedLeague'];
            let early = store.getters['FeedDballModule/getEarlyFeedLeague'];

            return { ...live, ...today, ...early };
        },
        getFeedTeam(state) {
            let live = store.getters['FeedLiveModule/getFeedTeam'];
            let today = store.getters['FeedDballModule/getTodayFeedTeam'];
            let early = store.getters['FeedDballModule/getEarlyFeedTeam'];

            return { ...live, ...today, ...early };
        },
        getGamesIdx(state) {
            let live = store.getters['FeedLiveModule/getGamesIdx'];
            let today = store.getters['FeedDballModule/getGamesIdx'];
            let early = store.getters['FeedDballModule/getGamesIdx'];

            return { ...live, ...today, ...early };
        },
    },

    actions: {
        ...mixinActions('favourite'),
        ...feedActions('favourite'),

        update(context, item) {
            return axios.post('/api/favoriteEvent/update', { rows: [item] }).then((response) => {
                if (response.data.success) {
                    // let index = context.state.favoriteGame.indexOf(item.ceId);
                    // context.state.favoriteGame.splice(index, 1);
                }
            });
        },

        orderBy(context, item) {
            return axios.post('/api/favoriteEvent/orderBy', item).then((response) => {
                if (response.data.success) {
                    // let index = context.state.favoriteGame.indexOf(item.ceId);
                    // context.state.favoriteGame.splice(index, 1);
                }
            });
        },
    },
};
